export const SESSION_RECOVERY_QUERY_PARAM = 'recoverSession';
export const SESSION_RECOVERY_REQUIRED_HEADER =
  'X-DirectorDeck-Session-Recovery';
export const CLIENT_AUTH_RECOVERY_REQUIRED_HEADER =
  'X-DirectorDeck-Client-Auth-Recovery';
export const SESSION_STATUS_ENDPOINT = '/api/session/status';
export const RECOVERY_HEADER_VALUE = 'required';
export const RECOVERY_EXPOSED_HEADERS = [
  SESSION_RECOVERY_REQUIRED_HEADER,
  CLIENT_AUTH_RECOVERY_REQUIRED_HEADER,
] as const;
